import { MdChevronRight } from 'react-icons/md'
import ScrollContainer from 'react-indiana-drag-scroll'
import Institutes from './institutes'
import SideMenu from '../sideMenu/sideMenu'
import Banner from '../banner/banner'
import AnimatedPage from '../animatedPage'
import { FaArrowRight } from 'react-icons/fa6'
import { useRef, useState } from 'react'
import { PropTypes } from 'prop-types'
import Happening from './happening'
import ModelButton from '../modelBtn/modelButton'
import ContactUsPopUp from './irmc/contactUsPopUp'

const Pages = ({ text, bg, list, data, contactUs, contents }) => {
  const container = useRef(null)

  const handleScroll = () => {
    if (container.current) {
      container.current.scrollBy({ left: 500, behavior: 'smooth' })
    }
  }
  const [modalOpen, setModalOpen] = useState(false)

  const closed = () => setModalOpen(false)
  const open = () => contactUs != undefined && setModalOpen(true)

  return (
    <AnimatedPage>
      <Banner text={text} bg={bg} />
      <div className='flex justify-center bg-white p-4 md:py-12 w-full'>
        <div className='w-full flex flex-col gap-5 lg:px-16  '>
          <SideMenu list={list} contents={contents}>
            <div className='p-4 flex items-center w-full my-8'>
              <div className='flex w-full flex-col gap-3  py-10 items-center rounded-lg bg-[#02265B]'>
                <h2 className='w-auto max-w-[20ch] text-center font-bold text-white text-xl leading-tight'>{`Contact Us`}</h2>
                <>
                  <button
                    onClick={() => (modalOpen ? closed() : open())}
                    className='px-8 py-4 w-fit  bg-red-800 rounded justify-center items-center gap-4 flex'
                  >
                    <span className='text-white  text-base font-bold capitalize flex items-center gap-3'>
                      View Details <FaArrowRight />
                    </span>
                  </button>
                  <ModelButton modalOpen={modalOpen} close={closed}>
                    <ContactUsPopUp contactUs={contactUs} />
                  </ModelButton>
                </>
              </div>
            </div>
          </SideMenu>
        </div>
      </div>
      <div className='px-4 py-8 md:px-24 grid gap-16 my-8'>
        {data?.happenings && data.happenings.length > 0 && (
          <div className='grid gap-5 relative'>
            <div className='border-b border-b-[#393939] w-full py-2'>
              <h2 className='text-2xl font-bold'>happenings</h2>
            </div>
            <ScrollContainer
              innerRef={container}
              horizontal
              className='flex gap-5 w-full scroll-smooth snap-mandatory snap-x overflow-x-auto scroll-px-3 p-2 mt-2'
            >
              {data?.happenings?.map((happening, index) => (
                <Happening happening={happening} key={index} />
              ))}
            </ScrollContainer>
            <div
              onClick={handleScroll}
              className='w-12 h-12 absolute top-1/2 -translate-y-1/2 right-0 select-none font-bold shadow border cursor-pointer rounded-full bg-white grid place-items-center'
            >
              <MdChevronRight size={30} />
            </div>
          </div>
        )}
        {/* <Institutes data={data?.institutes} /> */}
      </div>
    </AnimatedPage>
  )
}

Pages.propTypes = {
  text: PropTypes.string,
  bg: PropTypes.string,
  list: PropTypes.array,
  contactUs: PropTypes.any,
  contents: PropTypes.array,
  data: PropTypes.object
}

export default Pages
